export function formatDisplayVersion(version: string): string {
  const match = version.match(/\d+\.\d+\.\d+/);
  return match?.[0] ?? version;
}
